import _ from 'lodash';
import config from '__mainSrcDir/config/app.config.js';
import { MULTIBOOK_EXTERNAL } from '__mainSrcDir/config';
const multibookConfig = require(`../../../package.json`).config;

let rectangleOffsetDefault = {
  x: -12,
  y: -12,
  width: 12,
  height: 12,
};
const state = {
  // podstawowe parametry;
  gridData: null,
  mainColor: '#f2f2f2',
  gameColor: '#f2f2f2',
  gameLevel: null,
  scale: 1,
  modalActive: false,
  allTopLayoutDisable: false,
  fullScreenActive: false,
  rectangleOffset: config.rectangleOffset || rectangleOffsetDefault,
  iconSize: config.iconSize || 75,
  realWidth: config.realWidth || 1920,
  realHeight: config.realHeight || 2277,
  /**
   * because we have to apply scaling and there are differences in the PDF and screen proportions we need to manually set all three parameters
   */

  /**
   * is set for scaling in X axis icons, rectagles itd
   */
  mainContenPageCapacity: config.mainContenPageCapacity || 89,
  /**
   * is set for scaling width background image for pages
   */
  mainContenWidth: config.mainContenWidth || 870,
  /**
   * is set for scaling height background image for pages
   */
  mainContenHeight: config.mainContenHeight || (1080 * 86.2) / 100,
  headerBarOffset: config.headerBarOffset || 142,
  baseFont: config.baseFont || 'Myriad Pro',
  showDevlopmentBar: config.showDevlopmentBar || false,
  showElectronOnlyIcons: config.showElectronOnlyIcons || true,
  isWeb: config.isWeb,
  multibookType: config.multibookType || '',
  multibookListIndexShow: config.multibookListIndexShow || '',
  realMultibookType: null,
  showIcons: false,

  // info message
  cacheStatus: config.cacheStatus || false,
  devTool: config.devTool || false,
  bookIndexDisable: config.bookIndexDisable || true,
  multiconfig: multibookConfig.external,
};

const mutations = {
  SET_MAIN_COLOR(state, color) {
    state.mainColor = color;
  },
  SET_GAME_COLOR(state, color) {
    state.gameColor = color;
  },
  SET_GAME_LEVEL(state, lvl) {
    state.gameLevel = lvl;
  },
  SET_GRID_DATA(state, data) {
    state.gridData = data;
  },
  CHANGE_SCALE(state, scale) {
    state.scale = scale;
  },
  CHANGE_BOOK_INDEX_DISABLE(state, a) {
    state.bookIndexDisable = a;
  },
  TOGGLE_FULL_SCREEN_ACTIVE(state, fullScreenState) {
    state.fullScreenActive = fullScreenState;
  },
  TOGGLE_MODAL_ACTIVE(state, modalActive) {
    state.modalActive = modalActive;
  },
  TOGGLE_UI_DISABLE(state, allTopLayoutDisable) {
    state.allTopLayoutDisable = allTopLayoutDisable;
  },
  CHANGE_MULTIBOOK_TYPE(state, type) {
    state.multibookType = type;
  },
  CHANGE_REAL_MULTIBOOK_TYPE(state, type) {
    state.realMultibookType = type;
  },
  CHANGE_CACHE_STATUS(state, value) {
    state.cacheStatus = value;
  },
  DISABLE_MULTIBOOK_LIST(state) {
    state.multibookListShow = false;
  },
  DISABLE_PAGE_ICONS(state, value) {
    state.showIcons = value;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER');
  },
};

const getters = {
  getMainColor: (state) => {
    return state.mainColor;
  },
  getGameColor: (state) => {
    return state.gameColor;
  },
  getGameLevel: (state) => {
    return state.gameLevel;
  },
  getGridData: (state) => {
    return state.gridData;
  },
  getDefaultFont: (state) => {
    return state.baseFont;
  },
  bookIndexDisable: (state) => {
    return state.bookIndexDisable;
  },
  mainContenWidth: (state) => {
    return state.mainContenWidth;
  },
  mainContenHeight: (state) => {
    return state.mainContenHeight;
  },
  realWidth: (state) => {
    return state.realWidth;
  },
  realHeight: (state) => {
    return state.realHeight;
  },
  headerBarOffset: (state) => {
    return state.headerBarOffset;
  },
  mainContenPageCapacity: (state) => {
    return state.mainContenPageCapacity;
  },
  scale: (state) => {
    return state.scale;
  },
  iconSize: (state) => {
    return state.iconSize;
  },
  modalActive: (state) => {
    return state.modalActive;
  },
  allTopLayoutDisable: (state) => {
    return state.allTopLayoutDisable;
  },

  fullScreenActive: (state) => {
    return state.fullScreenActive;
  },
  rectangleOffset: (state) => {
    return state.rectangleOffset;
  },
  showDevlopmentBar: (state) => {
    return state.showDevlopmentBar;
  },
  showElectronOnlyIcons: (state) => {
    return state.showElectronOnlyIcons;
  },
  isWeb: (state) => {
    return state.isWeb;
  },
  multibookType: (state) => {
    return state.multibookType;
  },
  realMultibookType: (state) => {
    return state.realMultibookType;
  },
  cacheStatus: (state) => {
    return state.cacheStatus;
  },
  multiconfig: (state) => {
    return state.multiconfig;
  },
  multiconfigTest: (state) => {
    return _.isArray(state.multiconfig);
  },
  multibookListShow: (state) => {
    return state.multibookListShow;
  },
  showIcons: (state) => {
    return state.showIcons;
  },
  multibookListIndexShow: (state) => {
    return state.multibookListIndexShow;
  },
  devTool: (state) => {
    return state.devTool;
  },
};
export default { state, mutations, actions, getters };
